import { Currency, CurrencySelect, LanguageSelect } from '@components'

import { Icon } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { selectableInvoiceLanguages } from '../../../../../../../invoices/constants/selectableInvoiceLanguages'
import { useCustomerForm } from '../../../../contexts/customerFormContext'

export const InvoicingLanguageAndCurrency = (): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <>
      <FormItem
        itemColumnEnd={6}
        itemColumnStart={1}
        name="language"
        label={t('customer_modal.form.language.label')}
        render={({ field: { value, onChange, ...rest } }) => (
          <LanguageSelect
            {...rest}
            defaultSelectedId={value}
            languages={selectableInvoiceLanguages}
            onSelect={onChange}
            placement="top-start"
            selectedId={value}
            size="sm"
            withSearch={false}
          />
        )}
      />
      <FormItem
        itemColumnEnd={11}
        itemColumnStart={6}
        name="currency"
        label={t('customer_modal.form.currency.label')}
        render={({ field: { value, onChange, ...rest } }) => (
          <CurrencySelect
            {...rest}
            onSelect={(_id?: string, value?: Currency) => onChange(value?.id)}
            placement="top-start"
            prefix={<Icon icon="coins" />}
            selectedId={value}
            size="sm"
          />
        )}
      />
    </>
  )
}
